export default "__VITE_ASSET__6976ddac__"